import * as serverApi from './server';

export const singleFileUpload = (payload) => serverApi.post('/files/single', payload);
export const getFileAccessAPI = (payload) => serverApi.get('/files', payload);
